/**
 * Computes the If-Modified-Since header value for a shot.
 *
 * We subtract one second before flooring to HTTP-date's 1-second resolution.
 * This ensures a frame written at the exact shot second satisfies
 * Last-Modified > If-Modified-Since per RFC 7232 §3.3.
 */
export function toIfModifiedSince(shotTimestampMs: number): string {
  return new Date(
    Math.floor((shotTimestampMs - 1_000) / 1_000) * 1_000
  ).toUTCString();
}
